import React from "react";
import Card from "components/card";
import { Globe } from "lucide-react";
import ClockCard from "./ClockCard";

const WorkClock = () => {
    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 bg-white">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pb-6 bg-slate-50 border-b border-slate-200 pt-3">
                <div className="flex items-center gap-2">
                    <Globe className="w-4 h-4 text-blue-600" />
                    <div>
                        <h4 className="text-[15px]">World Clock & Working Hours</h4>
                        <p className="text-slate-700 text-[11px]">
                            Standard hours: 7:00 AM - 4:00 PM
                        </p>
                    </div>
                </div>
            </div>
            <div className="pb-6 p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <ClockCard 
                        country="Philippines"
                        city="Manila"
                        timezone="Asia/Manila"
                        variant="blue"
                    />
                    <ClockCard 
                       country="Australia"
                        city="Sydney"
                        timezone="Australia/Sydney"
                        variant="purple"
                    />
                </div>
            </div>
        </Card>
    )
};
export default WorkClock;